<template>
  <div>
    <v-container style="max-width: 1000px">
      <v-layout wrap class="mb-4">
        <v-flex xs9>
          <h3 class="headline">{{ $t('Payment Detail') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditPaymentDetail"
            @click="isEditPaymentDetail = true"
          >
            <i class="fa fa-pencil-alt middle"></i>
          </v-btn>
        </v-flex>
      </v-layout>
      <shipping-detail
        :isEdit="isEditPaymentDetail"
        :init="contents"
        @onSave="isEditPaymentDetail = false"
      ></shipping-detail>
    </v-container>
    <v-divider></v-divider>
    <v-container style="max-width: 1000px">
      <v-layout wrap>
        <v-flex xs9>
          <h3 class="headline">{{ $t('Profile') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn fab outline small color="primary" @click="isEditShop = true" v-if="!isEditShop">
            <i class="fa fa-pencil-alt middle"></i>
          </v-btn>
        </v-flex>
      </v-layout>
      <label for="pageName">{{ $t('Page name') }}</label>
      <h6>{{ profile.pagename }}</h6>
      <label for="pageDescription">{{ $t('Page description') }}</label>
      <div class="form-control">
        <div v-if="isEditShop">
          <!-- <tooltip v-model="showSaveDescription">Saved</tooltip> -->
          <textarea
            v-model="profile.description"
            class="form-control"
            rows="5"
            style="resize:vertical;min-height: 90px"
            @change="isChangeDescription = true"
            :placeholder="$t('Page description')"
          ></textarea>
        </div>
        <div v-else>
          <h6>{{ profile.description ? profile.description : '-' }}</h6>
        </div>
      </div>
      <label for="pageShortLink">{{ $t('Page short link') }}</label>
      <a href="javascript:void(0);" @click="resetPageShortLink" v-if="isEditShop">
        <i class="fas fa-redo-alt"></i>
      </a>

      <div class="form-control" :class="{ 'has-error': errors.has('pageShortLinkInput') }">
        <div v-if="isEditShop">
          <!-- <tooltip v-model="showSaveShortlink">Saved</tooltip> -->
          <span>https://shop.zwiz.ai/ecommerce/</span>
          <input
            style="display:inline-block;min-width: 200px;width: auto;"
            class="form-control"
            v-model="profile.pageshortlink"
            name="pageShortLinkInput"
            :data-vv-as="$t('Page short link')"
            @change="isChangeShortlink = true"
            v-validate="'required|alpha_dash'"
          />
          <div>
            <span class="text-error" v-show="errors.has('pageShortLinkInput')">{{
              errors.first('pageShortLinkInput')
            }}</span>
          </div>
        </div>
        <p style="word-break: break-all;" v-else>
          <a
            target="BLANK"
            :href="
              'https://shop.zwiz.ai/ecommerce/' +
                (profile.pageshortlink && profile.pageshortlink != ''
                  ? profile.pageshortlink
                  : selectedBot.pageid)
            "
          >
            <template v-if="profile.pageshortlink && profile.pageshortlink != ''"
              >https://shop.zwiz.ai/ecommerce/{{ profile.pageshortlink }}</template
            >
            <template v-else
              >https://shop.zwiz.ai/ecommerce/{{ selectedBot.pageid }}</template
            >
          </a>
        </p>
      </div>

      <div class="mb-3">
        <label for>
          {{ $t('Shop Color') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>
        <template v-if="isEditShop && $store.getters.getPackage == 'premium'">
          <swatches v-model="color"></swatches>
        </template>
        <template v-else>
          <div
            style="width: 50px; height: 50px; border-radius: 10px"
            :style="{ background: color }"
          ></div>
        </template>
      </div>

      <div>
        <label for>
          {{ $t('Shop Language') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>
      </div>
      <div class="mb-3">
        <template v-if="isEditShop && $store.getters.getPackage == 'premium'">
          <multiselect
            v-model="lang"
            :options="langOptions"
            label="label"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            track-by="label"
            @select="onSelectLang"
          ></multiselect>
        </template>
        <div v-else class="primary-color">{{ lang.label }}</div>
      </div>

      <div>
        <label for>{{ $t('Shop address') }}</label>
      </div>

      <div>
        <template v-if="isEditShop">
          <div class="form-control">
            <textarea
              v-model="profile.pageaddress"
              :placeholder="$t('Shop address')"
              class="form-control"
              rows="5"
              style="resize:vertical;min-height: 90px;"
            ></textarea>
          </div>
          <div class="text-xs-center mb-3">
            <v-btn outline color="grey" @click="cancelEditProfile">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="saveProfile">{{ $t('Save') }}</v-btn>
          </div>
        </template>
        <template v-else>
          <p class="primary-color">{{ profile.pageaddress ? profile.pageaddress : '-' }}</p>
        </template>
      </div>
    </v-container>
    <v-divider></v-divider>
    <v-container style="max-width: 1000px">
      <v-layout wrap>
        <v-flex xs9>
          <h3 class="headline">{{ $t('Additional messages after order summary') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <template v-if="$store.getters.getPackage == 'premium'">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditOrderSummaryMessage"
              @click="isEditOrderSummaryMessage = true"
            >
              <i class="fa fa-pencil-alt middle"></i>
            </v-btn>
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn readonly fab outline small color="grey" v-on="on">
                  <v-icon>lock</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Upgrade to Premium Plan') }}</span>
            </v-tooltip>
          </template>
        </v-flex>
      </v-layout>

      <div v-if="wordafter.loading">
        <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
      </div>

      <v-layout wrap v-else>
        <v-flex xs12 sm6 class="border-right pa-1">
          <view-cart-summary-viewer></view-cart-summary-viewer>

          <template v-if="isEditOrderSummaryMessage">
            <div
              class="message"
              style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div style="padding: 8px 6px 2px;background-color:#F1F0F0">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errors.has('answer_word_cart_summary') }"
                    >
                      <autoresize-textarea
                        maxlength="640"
                        ref="answer_word_cart_summary"
                        class
                        :placeholder="$t('Chatbot answers')"
                        v-model="wordafter.wordscartsummary.text"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_word_cart_summary'"
                        v-validate
                        style="resize: none;display: inherit;margin-bottom: 5px;"
                      ></autoresize-textarea>

                      <span class="text-error" v-show="errors.has('answer_word_cart_summary')">{{
                        errors.first('answer_word_cart_summary')
                      }}</span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="clearfix"></div>
            </div>

            <intent-prefill @addIntentPrefill="addWordCartSummaryPrefill($event)"></intent-prefill>
          </template>
          <template v-else>
            <div
              class="message"
              v-if="
                wordafter.wordscartsummary.text != '' && wordafter.wordscartsummary.type == 'text'
              "
              style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
            >
              <div style="font-size: 12px;" :style="{ color: 'black' }">
                <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
                  <span style="line-height:15.36px; line-height: 22px;">
                    <template v-if="wordafter.wordscartsummary.text != ''">
                      <specialtext :text="wordafter.wordscartsummary.text"></specialtext>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </template>
          <v-divider class="hidden-sm-and-up"></v-divider>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <view-receipt-viewer></view-receipt-viewer>
          <template v-if="isEditOrderSummaryMessage">
            <div
              class="message"
              style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div style="padding: 8px 6px 2px;background-color:#F1F0F0">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errors.has('answer_word_orders') }"
                    >
                      <autoresize-textarea
                        maxlength="640"
                        ref="answer_word_orders"
                        class
                        :placeholder="$t('Chatbot answers')"
                        v-model="wordafter.wordsorders.text"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_word_orders'"
                        v-validate
                        style="resize: none;display: inherit;margin-bottom: 5px;"
                      ></autoresize-textarea>

                      <span class="text-error" v-show="errors.has('answer_word_orders')">{{
                        errors.first('answer_word_orders')
                      }}</span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="clearfix"></div>
            </div>

            <intent-prefill @addIntentPrefill="addWordOrderPrefill($event)"></intent-prefill>
          </template>
          <template v-else>
            <div
              class="message"
              v-if="wordafter.wordsorders.text != '' && wordafter.wordsorders.type == 'text'"
              style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
            >
              <div style="font-size: 12px;" :style="{ color: 'black' }">
                <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
                  <span style="line-height:15.36px; line-height: 22px;">
                    <template v-if="wordafter.wordsorders.text != ''">
                      <specialtext :text="wordafter.wordsorders.text"></specialtext>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </v-flex>
      </v-layout>

      <div class="text-xs-center" v-if="isEditOrderSummaryMessage">
        <v-btn outline color="grey" @click="cancelEditWordAfterOrderAndCartSummary">{{
          $t('cancel')
        }}</v-btn>
        <v-btn depressed color="primary" @click="saveWordAfterOrderAndCartSummary">{{
          $t('Save')
        }}</v-btn>
      </div>
    </v-container>
    <v-divider></v-divider>
    <v-container style="max-width: 1000px">
      <v-layout wrap>
        <v-flex xs9>
          <h3 class="headline">
            {{ $t('Bank Transfer') }}
            <input-boolean-no-label
              v-model="contents.allowtransfer"
              @onInputChange="isTransfer = !isTransfer"
            ></input-boolean-no-label>
          </h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditTransfer"
            @click="isEditTransfer = true"
          >
            <i class="fa fa-pencil-alt middle"></i>
          </v-btn>
        </v-flex>
      </v-layout>
      <transfer-payment
        :isEdit="isEditTransfer"
        @onSave="isEditTransfer = false"
        :init="contents"
      ></transfer-payment>
    </v-container>
    <v-divider></v-divider>

    <v-container style="max-width: 1000px">
      <h3 class="headline">
        {{ $t('Credit card') }}
        <template v-if="selectedBot.paypal_merchantid != null">
          <input-boolean-no-label
            v-model="contents.allowcreditcard"
            @onInputChange="isCreditCard = !isCreditCard"
          ></input-boolean-no-label>
        </template>
      </h3>

      <div v-if="selectedBot.paypal_merchantid != null">
        {{ $t('Connected with PayPal merchant id') }}:
        <p class="small primary-color">{{ selectedBot.paypal_merchantid }}</p>
      </div>

      <div v-show="!selectedBot.paypal_merchantid">
        <div v-show="!paypal.haveTrackingId">
          <p>{{ $t('to activate credit card payment, please click Link PayPal Account') }}</p>
          <p class="small" style="font-size: 12px;">
            {{
              $t(
                '(Accept credit/debit card through Paypal channel, with only 3.4% fee for domestic transaction, withdraw to your bank account in 3-5 days)'
              )
            }}
          </p>
          <div v-show="!paypal.loading">
            <div>
              <div style="display:flex;">
                <div
                  @click="registerPaypalMerchant"
                  style="cursor: pointer;display: table-cell; vertical-align: middle;background: white;overflow: auto;border: 1px solid #b1aeae;border-right: 0; border-top-left-radius: 5px;border-bottom-left-radius: 5px;"
                >
                  <img
                    src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png"
                    alt
                    style="padding: 10px 10px;background: #fff;    width: 100%;"
                  />
                </div>
                <div
                  @click="registerPaypalMerchant"
                  style="cursor: pointer;background: #002f86;border: 1px solid #b1aeae;border-left: 0; border-top-right-radius: 5px;border-bottom-right-radius: 5px;"
                >
                  <p
                    style="padding: 15px 15px; margin: 0; max-width: 180px;color: white; white-space: nowrap"
                  >
                    {{ $t('Link PayPal Account') }}
                  </p>
                </div>
              </div>
              <a
                href="javascript:void(0);"
                style="vertical-align: top;display: inline-block;margin-top: 14px;"
                @click="showHelpRegisterPaypal = true"
                >{{ $t('how to link PayPal Account?') }}</a
              >
            </div>
          </div>

          <div v-show="paypal.loading">
            <sync-loader
              :color="$vuetify.theme.primary"
              :size="'10px'"
              style="display:inline-block;margin-right: 10px;margin-bottom: 15px;"
            ></sync-loader>
            {{ $t('Loading') }}
          </div>
        </div>
        <div v-show="paypal.haveTrackingId">
          <div style="margin-bottom: 15px;">
            <template v-if="paypal.checkTracking">
              <sync-loader
                :color="$vuetify.theme.primary"
                :size="'10px'"
                style="display:inline-block;margin-right: 10px"
              ></sync-loader>
              <span style="display:inline">{{
                $t('Pending PayPal Merchant Account Registration')
              }}</span>
            </template>
            <template v-else>
              <a href="javascript:void(0);" @click="onRefreshTrackingStatus">
                <i class="fas fa-sync-alt"></i>
                {{ $t('Click refresh after you have completed registration') }}
              </a>
            </template>
            |
            <a href="javascript:void(0);" @click="cancelRegisterPaypalMerchant">{{
              $t('cancel')
            }}</a>
          </div>
        </div>

        <modal-dialog v-if="showHelpRegisterPaypal" @close="showHelpRegisterPaypal = false">
          <span slot="header"></span>

          <div slot="body">
            <h5 class="text-xs-center">{{ $t('How to link PayPal Account') }}</h5>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">{{ $t('1. Click Link PayPal Account button') }}</p>
              <img
                src="/static/img/assets/setting/register_paypal/step1.png"
                style="width: 100%; margin: auto"
                alt
              />
            </div>
            <div class="hr"></div>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">
                {{ $t('2. input email and select Thailand and then click on Next button') }}
              </p>
              <img
                src="/static/img/assets/setting/register_paypal/step2.png"
                style="width: 100%; margin: auto"
                alt
              />
            </div>
            <div class="hr"></div>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">
                {{ $t('3. complete details in form (select Thailand, and THB only)') }}
              </p>
              <img
                src="/static/img/assets/setting/register_paypal/step3.png"
                style="width: 100%; margin: auto"
                alt
              />
            </div>
            <div class="hr"></div>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">
                {{ $t('4. Accept to connect with Robolingo Co., Ltd.') }}
              </p>
              <img
                src="/static/img/assets/setting/register_paypal/step4.png"
                style="width: 100%; margin: auto"
                alt
              />
            </div>
            <div class="hr"></div>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">
                {{ $t('5. verify e-mail and click ใช่ นี่คือที่อยู่อีเมลของฉัน button') }}
              </p>
              <img
                src="/static/img/assets/setting/register_paypal/step4_1.png"
                style="width: 100%; margin: auto"
                alt
              />
            </div>
            <div class="hr"></div>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">
                {{
                  $t(
                    '6. Wait for processing and click Try to get PayPal merchant id again button to check connection with PayPal'
                  )
                }}
              </p>
              <img
                src="/static/img/assets/setting/register_paypal/step5.png"
                style="width: 100%; margin: auto"
                alt
              />
            </div>
            <div class="hr"></div>
            <div style="margin-top: 15px;margin-bottom: 25px;text-align: center">
              <p style="padding: 0 15px">
                {{
                  $t(
                    '7. After you register successfully you will see merchant id on this page. If you can not register, please contact'
                  )
                }}
                <a :href="'mailto:' + $store.state.theme.email_contact">{{
                  $store.state.theme.email_contact
                }}</a>
              </p>
              <img
                src="/static/img/assets/setting/register_paypal/step6.png"
                style="max-width: 300px; width: 100%; margin: auto"
                alt
              />
            </div>
          </div>

          <div slot="footer">
            <div class="row text-xs-center">
              <a
                href="javascript:void(0);"
                class="btn btn-primary"
                @click="showHelpRegisterPaypal = false"
                >{{ $t('cancel') }}</a
              >
            </div>
          </div>
        </modal-dialog>
      </div>
    </v-container>

    <div class="mb-5 mt-5"></div>
  </div>
</template>

<script>
import InputBooleanNoLabel from '@/components/view/setting/input-no-label/InputBooleanNoLabel'
import TransferPayment from '@/components/view/setting/ecommerce/TransferPayment'
import ShippingDetail from '@/components/view/setting/ecommerce/ShippingDetail'
import { mapGetters } from 'vuex'
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import ModalDialog from '@/components/elements/ModalDialog'

import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import Multiselect from 'vue-multiselect'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewReceiptViewer from '@/components/elements/ViewReceiptViewer'
import specialtext from '@/components/elements/specialtext'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  data: function() {
    return {
      isEditPaymentDetail: false,
      isEditShop: false,
      isEditTransfer: false,
      isEditOrderSummaryMessage: false,
      contents: {},
      isTransfer: false,
      isCreditCard: false,
      paypal: {
        paypal_url: null,
        tracking_id: null,
        loading: true,
        checkTracking: false,
        haveTrackingId: false,

        checkingInterval: null,
        checkingTime: 4,
        checkingTimePerInterval: 5000
      },
      profile: {},
      oldProfile: {},
      showHelpRegisterPaypal: false,
      color: '#1CA085',
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      wordafter: {
        loading: true,
        wordscartsummary: {
          type: 'text',
          text: ''
        },
        wordsorders: {
          type: 'text',
          text: ''
        }
      }
    }
  },
  components: {
    ShippingDetail,
    InputBooleanNoLabel,
    TransferPayment,
    SyncLoader,
    ModalDialog,
    Swatches,
    Multiselect,
    ViewCartSummaryViewer,
    ViewReceiptViewer,
    specialtext,
    IntentPrefill,
    AutoresizeTextarea,
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      paypalTrackingId: 'paypalTrackingId',
      currentLang: 'currentLang'
    })
  },
  created: function() {
    var vm = this
    vm.paypal.haveTrackingId = vm.paypalTrackingId != null
    vm.paypal.checkTracking = vm.paypal.haveTrackingId && vm.selectedBot.paypal_merchantid == null
    vm.$store.dispatch('loadCharges')
    vm.$store.dispatch('loadSetting')
    vm.getWordAfterOrderAndCartSummary()
    vm.getSetting()
    vm.getShopProfile()
    if (vm.selectedBot.theme === 'ecommercebasic') {
      if (vm.selectedBot.paypal_merchantid == null) {
        if (vm.paypalTrackingId == null) {
          vm.getPaypalUrl()
        } else {
          if (vm.paypal.checkTracking) {
            vm.onRefreshTrackingStatus()
          }
        }
      }
    }
  },
  mounted: function() {
    ;(function(d, s, id) {
      var js,
        ref = d.getElementsByTagName(s)[0]
      if (!d.getElementById(id)) {
        js = d.createElement(s)
        js.id = id
        js.async = true
        js.src = 'https://www.paypal.com/webapps/merchantboarding/js/lib/lightbox/partner.js'
        ref.parentNode.insertBefore(js, ref)
      }
    })(document, 'script', 'paypal-js')
  },
  methods: {
    addWordCartSummaryPrefill: function(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_cart_summary.$el.selectionStart

      vm.wordafter.wordscartsummary.text = [
        vm.wordafter.wordscartsummary.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordscartsummary.text.slice(cursorPosition)
      ].join('')
    },
    addWordOrderPrefill: function(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_orders.$el.selectionStart
      vm.wordafter.wordsorders.text = [
        vm.wordafter.wordsorders.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordsorders.text.slice(cursorPosition)
      ].join('')
    },
    onSelectLang: function(val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function(setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    },
    getWordAfterOrderAndCartSummary: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      vm.wordafter.loading = true
      api.getWordAfterOrderAndCartSummary(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.wordafter.loading = false
          return
        }
        if (response.data) {
          if (response.data.wordscartsummary) {
            vm.wordafter.wordscartsummary = JSON.parse(response.data.wordscartsummary)
          }
          if (response.data.wordsorders) {
            vm.wordafter.wordsorders = JSON.parse(response.data.wordsorders)
          }
        }
        vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
        vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
        vm.wordafter.loading = false
      })
    },
    cancelEditWordAfterOrderAndCartSummary: function() {
      var vm = this
      vm.wordafter.wordscartsummary = JSON.parse(vm.cached_wordscartsummary)
      vm.wordafter.wordsorders = JSON.parse(vm.cached_wordsorders)
      vm.isEditOrderSummaryMessage = false
    },
    saveWordAfterOrderAndCartSummary: function() {
      var vm = this
      let data = {
        wordscartsummary: JSON.stringify(vm.wordafter.wordscartsummary),
        wordsorders: JSON.stringify(vm.wordafter.wordsorders),
        pageid: vm.selectedBot.pageid
      }
      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.wordafter.loading = true
        api.saveWordAfterOrderAndCartSummary(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.wordafter.loading = false
            return
          }
          vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
          vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
          vm.wordafter.loading = false
          vm.isEditOrderSummaryMessage = false
        })
      })
    },
    getShopProfile: function() {
      let data = {
        pageid: this.selectedBot.pageid
      }
      let vm = this
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.shopprofile) {
          vm.profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          vm.oldProfile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          var findLang = vm.langOptions.find(function(el) {
            return el.value == response.shopprofile.shoplang
          })

          if (findLang) {
            vm.lang = findLang
          } else {
            vm.lang = vm.langOptions[1]
          }

          vm.color = response.shopprofile.shopcolor ? response.shopprofile.shopcolor : '#1CA085'
        }
      })
    },
    saveProfile: function() {
      let vm = this
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.selectedBot.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid
      }
      if (vm.$store.getters.getPackage == 'premium') {
        data.shoplang = vm.profile.shoplang
        data.shopcolor = vm.color
      }

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        api.editShopProfile(data, function(error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.isEditShop = false
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
        })
      })
    },

    resetPageShortLink: function() {
      if (!this.selectedBot.pageid || this.selectedBot.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.selectedBot.pageid
    },
    cancelEditProfile: function() {
      var vm = this
      this.profile.description = this.oldProfile.description
      this.profile.pageaddress = this.oldProfile.pageaddress
      this.profile.pageshortlink = this.oldProfile.pageshortlink
      var findLang = vm.langOptions.find(function(el) {
        return el.value == vm.oldProfile.shoplang
      })

      if (findLang) {
        vm.lang = findLang
      } else {
        vm.lang = vm.langOptions[1]
      }
      this.isEditShop = false
    },
    getPaypalUrl: function() {
      var vm = this
      vm.paypal.loading = true
      var data = []
      api.getPaypalUrl(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.paypal.paypal_url = response.data.links[1].href
        document.getElementById('actionId').href = vm.paypal.paypal_url + '&displayMode=minibrowser'
        vm.paypal.tracking_id = response.tracking_id
        vm.paypal.loading = false
      })
    },
    registerPaypalMerchant: function() {
      var vm = this

      document.getElementById('actionId').click()

      vm.$store.dispatch('updatePaypalTrackingId', vm.paypal.tracking_id)

      vm.paypal.haveTrackingId = true
      vm.paypal.checkTracking = true
      vm.onRefreshTrackingStatus()
    },
    cancelRegisterPaypalMerchant: function() {
      var vm = this
      if (vm.paypal.checkingInterval != null) {
        clearInterval(vm.paypal.checkingInterval)
      }
      this.getPaypalUrl()
      this.paypal.haveTrackingId = false
      this.paypal.checkTracking = false
      vm.$store.dispatch('updatePaypalTrackingId', null)
    },
    onRefreshTrackingStatus: function() {
      var vm = this
      vm.paypal.checkingTime = 6
      vm.paypal.checkTracking = true

      vm.checkingTrackingStatus(function(status) {
        if (status) {
          clearInterval(vm.paypal.checkingInterval)
          vm.paypal.checkTracking = false
        } else {
          vm.paypal.checkingInterval = setInterval(() => {
            vm.checkingTrackingStatus(function(status) {
              if (vm.paypal.checkingTime === 0 || status) {
                clearInterval(vm.paypal.checkingInterval)
                vm.paypal.checkTracking = false
              }
              vm.paypal.checkingTime--
            })
          }, vm.paypal.checkingTimePerInterval)
        }
      })
    },
    checkingTrackingStatus: function(callback) {
      var vm = this
      var data = {
        tracking_id: vm.paypalTrackingId
      }
      api.getPaypalTrackingStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        if (response.status === 'pending') {
          callback(false)
        } else if (
          response.status === 'success' &&
          response.merchant_id !== '' &&
          response.merchant_id != null
        ) {
          data = {
            pageid: vm.selectedBot.pageid,
            paypal_merchantid: response.merchant_id
          }
          api.updatePaypalMerchantId(data, function(error, response) {
            if (error) {
              console.error(error)
              return
            }
            vm.contents.allowcreditcard.contentvalue = true

            vm.$store.dispatch('updateMerchantId', data.paypal_merchantid)

            callback(true)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Payment.vue